import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgEnergyEfficiency = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 20" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M8.9 0H35v20H8.9L0 9.6z" /><path d="M34.6 0h-8v20h8z" style={{
      fill: "#fff"
    }} /><path d="M30.6 16.5h1v.6c0 .1-.3.2-.5.3s-.3.1-.5.1c-.3 0-.6-.1-.8-.4s-.4-.8-.4-1.4 0-1 .3-1.3.5-.4.9-.4.4.1.6.2.3.3.3.6l.8-.2c0-.5-.3-.8-.6-1.1s-.7-.4-1.2-.4-.8.1-1.1.3-.4.6-.6 1-.3.8-.3 1.4 0 1 .3 1.4.4.7.7.9.7.3 1.1.3.7-.1 1-.2.6-.3.8-.5v-2h-1.8zm-.9-11.1h1.6l.4 1.1h.9l-1.6-5h-.9l-1.6 5h.9zm.9-2.7.6 1.9H30zm1.5 6.2-1.6-1.4-1.7 1.4.6.6.7-.6v3.3h.8V8.9l.6.6z" /><path d="M9 20h26.1V0H9L0 9.6zm25.6-.5H9.3L.7 9.6 9.3.5h25.3z" /></SvgIcon>;
};
const Memo = memo(SvgEnergyEfficiency);
export default Memo;